import { render, staticRenderFns } from "./AudioNotice.vue?vue&type=template&id=201d2912"
import script from "./AudioNotice.vue?vue&type=script&lang=js"
export * from "./AudioNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports